import React, { useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../utils/msalConfig";
import { useNavigate } from 'react-router-dom';
import { checkUserRole } from '../../utils/authUtils';
import styles from '../../pages/Login.module.css';

const Login = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const handleLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);
            if (response.account) {
                const userEmail = response.account.username;
                const isAdmin = await checkUserRole(userEmail);
                const destination = isAdmin ? '/admin' : '/meetings';
                navigate(destination);
            }
        } catch (error) {
            setError('Login failed. Please try again.');
        }
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginBox}>
                <h1>Teams Meeting Manager</h1>
                <p>Sign in with your Microsoft account to continue</p>
                {error && <div className={styles.errorMessage}>{error}</div>}
                <button onClick={handleLogin} className={styles.loginButton}>
                    Sign in with Microsoft
                </button>
            </div>
        </div>
    );
};

export default Login;